<!--
 * @Author: Jarun
 * @Date: 2021-03-22 17:06:11
 * @LastEditTime: 2021-03-25 15:43:48
 * @LastEditors: Please set LastEditors
 * @Description: demo
 * @FilePath: \box.mengw.com\src\views\Demo\Demo.vue
-->

<template>
    <div class="find_wrap">
        <!-- S 顶部导航栏 -->
        <div class="header_wrap">
            <Tabs v-model:active="active" :before-change="changeTab">
                <Tab v-for="v in tabList" :key="v.name" :title="v.txt" :name="v.name"></Tab>
            </Tabs>

            <head-icon type="grey" v-if="miniapp !='miniapp'"></head-icon>
        </div>
        <!-- E 顶部导航栏 -->

        <div class="content_wrapper">
            <recommend v-if="active == 'rem'"></recommend>
            <sign-welfare v-else-if="active == 'welfare'"></sign-welfare>
            <SignLiveStream v-else-if="active == 'livestream'"></SignLiveStream>
            <attention v-else-if="active == 'attention'" :userInfo="userInfo"></attention>
        </div>
    </div>

    <!-- S 底部导航栏 -->
    <tabbar name="find"></tabbar>
    <!-- E 底部导航栏 -->
</template>

<script lang="js">
import { defineComponent, ref, reactive, toRefs, onBeforeMount, onMounted, onActivated, onDeactivated, computed} from 'vue';
import { useStore } from 'vuex';
import { Button, Tab, Tabs, Dialog,  } from 'vant';
import { onBeforeRouteLeave } from "vue-router"
import router from '@/router';
import Util from '@/assets/js/lib/util';
import Tabbar from '@/components/Seven_Tabbar/Tabbar.vue';
import HeadIcon from '@/components/Seven_HeadIcon/HeadIcon.vue';
import Recommend from '@/components/Git_Recommend/Recommend.vue';
import SignWelfare from '@/components/Git_SignWelfare/SignWelfare.vue';
import SignLiveStream from '@/components/Git_LiveStream/LiveStream.vue';
import Attention from '@/components/Git_Attention/Attention.vue';

export default defineComponent({
    name: 'Find',
    components: { Tabbar, HeadIcon,  Tab, Tabs, Recommend, SignWelfare, SignLiveStream, Dialog, Attention  },
    setup(props, { attrs, slots }) {
        const store = useStore();
        const state = reactive({
            util: new Util(),
            miniapp: '',
            userInfo: computed(() => store.state.userInfo),
            active: 'rem', //tab激活的name名称
            tabList: [{txt: '推荐', name: 'rem'},{txt: '直播', name: 'livestream'},{txt: '每日福利', name: 'welfare'},{txt: '关注', name: 'attention'}], //顶部tab {txt: '福利专题', name: 'special'}
        }); //变量
        const data = reactive({}); //数据

        const methods = {
            back: () => router.back(),
            goState: o => router.push(o),
            goLogin: (query) => {
                state.util.login({ query })
            },
            changeTab: (val) => {
                if(val == 'welfare'){
                    if (new Util().Cookie().get("access_token")) {
                        state.util.reportPageAction('/find/welfare');
                        return true;
                    }else {
                        Dialog.confirm({
                            message: '福利页面需要登录，是否马上前往登录',
                        })
                        .then(() => {
                            methods.goLogin({ routerurl: '/find?page=welfare' });
                        })
                        .catch(() => {

                        });
                    };
                }else if(val == 'livestream'){
                    state.util.reportPageAction('/find/livestream');
                    return true;
                }else if(val == 'rem'){
                    state.util.reportPageAction('/find/recommend');
                    return true;
                }else if(val == 'attention'){
                    if (new Util().Cookie().get("access_token")) {
                        state.util.reportPageAction('/find/attention');
                        return true;
                    }else {
                        Dialog.confirm({
                            message: '关注需要登录，是否马上前往登录',
                        })
                        .then(() => {
                            // methods.goState({name: 'login', query: { routerurl: '/find?page=attention' }});
                            methods.goLogin({ routerurl: '/find?page=attention' });
                        })
                        .catch(() => {

                        });
                    };
                }else{
                    state.util.winOpen(val);
                    return false;
                }
            },
        } //需要对外暴露的方法

        onBeforeMount(() => {
            let miniapp = sessionStorage.getItem('miniapp')
              if(miniapp){
                state.miniapp = miniapp
                state.tabList = [{txt: '推荐', name: 'rem'},{txt: '每日福利', name: 'welfare'}]
              }

            handleSign();
            getSpecial();
        });

        onActivated(() => {
            handleSign();
            let active =  router.currentRoute.value.query.page ? router.currentRoute.value.query.page : state.active;
            state.util.reportPageAction('/find/' + active);
            state.active = active;
        });

        onDeactivated(() => {

        });

        const handleSign = () => {
            if (!new Util().Cookie().get("access_token") && state.active == 'welfare') {
                state.active = 'rem';

                Dialog.confirm({
                    message: '福利页面需要登录，是否马上前往登录',
                })
                .then(() => {
                    // methods.goState({name: 'login', query: { routerurl: '/find?page=sign' }});
                    methods.goLogin({ routerurl: '/find?page=sign' });
                })
                .catch(() => {});
                return false;
            };

            if(router.currentRoute.value.query.page && router.currentRoute.value.query.page == 'sign'){
                if (new Util().Cookie().get("access_token")) {
                    state.active = 'welfare';
                }else {
                    Dialog.confirm({
                        message: '福利页面需要登录，是否马上前往登录',
                    })
                    .then(() => {
                        // methods.goState({name: 'login', query: { routerurl: '/find?page=sign' }});
                        methods.goLogin({ routerurl: '/find?page=sign' });
                    })
                    .catch(() => {
                        state.active = 'rem';
                    });
                }
            };
        }

        onBeforeRouteLeave((to, from) => {
            if(state.util.leaveIntercept(to)) return true; else return false;
        });

        const getSpecial = async () => { //获取专题
            const res = await state.util.getJson('/specialSubject', 'GET', {}, true);
            if(res.code == 0){
                for(var item in res.data){
                    state.tabList.push({txt: res.data[item].name, name: res.data[item].link});
                }
            }else {
                window.Components.toast(res.msg)
            }
        };

        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@import "./Find.less";
</style>
